module.exports = __webpack_public_path__ + "static/media/YF18_1.794671a5.jpg";